import { render, staticRenderFns } from "./PropertyTaxNotice.vue?vue&type=template&id=c9c83338&"
import script from "./PropertyTaxNotice.vue?vue&type=script&lang=js&"
export * from "./PropertyTaxNotice.vue?vue&type=script&lang=js&"
import style0 from "./PropertyTaxNotice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports